import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { MeetingRoom } from 'src/app/_model/meeting-room.model';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-add-update-meeting-room',
  templateUrl: './add-update-meeting-room.component.html',
  styleUrls: ['./add-update-meeting-room.component.css']
})
export class AddUpdateMeetingRoomComponent implements OnInit {
  myrole:string;userId:string;MeetingRoomForm: FormGroup;meetingRoomList=[];loading:boolean=false;submitted:boolean=false;meetingRoomId:any;from_time:any;to_time:any;meeting_room_access:string;
  constructor(private leadapi:LeadsService,private sharedapi:SharedService,private formBuilder: FormBuilder,private route:ActivatedRoute, private router: Router,private activatedRoute: ActivatedRoute, private elem: ElementRef) { 
    this.MeetingRoomForm = this.formBuilder.group({ 
      'room_name' : [null, Validators.required],
      'booking_date' : [null, Validators.required],
      'booking_from_time' : [null, Validators.required],
      'booking_to_time': [null],
      'purpose':[null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.meeting_room_access = localStorage.getItem('meeting_room_access');
    /* if((this.myrole=='1' || this.myrole=='3' || this.myrole=='5' || this.myrole=='6' || this.myrole=='9' || this.userId == '19' || this.userId == '20' || this.userId == '177'  || this.userId == '114') && this.userId != '205' && this.userId != '236') */
    if(this.meeting_room_access == '1')    
    {
      this.getMeetingRoomList();
    }
    else
    {
      this.router.navigateByUrl('/dashboard');
    }
    
    this.meetingRoomId = this.route.snapshot.paramMap.get("meeting_room_id");
    if(this.meetingRoomId)
    {
      this.getMeetingRoomBookedFormData();
    }
  }

  get f() { return this.MeetingRoomForm.controls; }


  getMeetingRoomBookedFormData(){
    this.leadapi.getMeetingRoomBookedFormData(this.meetingRoomId).subscribe((data:any) => {
      if(data.status){
        this.MeetingRoomForm.patchValue({
          'room_name':data.data.room_id,
          'booking_date':new Date(data.data.start_on*1000),
          'booking_from_time':data.data.booking_from_time,
          'booking_to_time':data.data.booking_to_time,
          'purpose':data.data.purpose,
        });
      }else{
        this.MeetingRoomForm.patchValue({
          'room_name':'',
          'booking_date':'',
          'booking_from_time':'',
          'booking_to_time':'',
          'purpose':'',
        });
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
          this.sharedapi.checkError(error);
    });
  }

  async getMeetingRoomList()
  {
      await this.leadapi.getMeetingRoomList().subscribe((data:any) => {
          if(data.status)
          {
            this.meetingRoomList = data.data;
          }else{
              this.meetingRoomList = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async get_end_time(event)
  {
    this.loading = true;
    this.from_time = event.target.value;
    await this.leadapi.getEndTime(this.from_time).subscribe((data:any) => {
      this.loading = false;
      this.to_time = data.data;
      this.submitted = false;
      this.MeetingRoomForm.patchValue({
        'booking_to_time': this.to_time,
      });
    }, error => 
    {
      this.loading = false;
      this.sharedapi.checkError(error);
    });
    
  }

  submitMeetingRoom()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.MeetingRoomForm.invalid) {
        this.loading = false;
        return;
    }
    if(this.meetingRoomId && this.meetingRoomId!='0'){
      this.MeetingRoomForm.value.id= this.meetingRoomId;
      this.leadapi.updateMeetingRoomBooking(this.MeetingRoomForm.value)
      .subscribe((data:MeetingRoom) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.sharedapi.presentToast(data.msg);
          setTimeout(() => {
            this.router.navigate(["update-meeting-room/"+this.meetingRoomId]);
          }, 2000);
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
      {
          this.sharedapi.checkError(error);
      });
    } else {
      this.leadapi.addMeetingRoomBooking(this.MeetingRoomForm.value)
      .subscribe((data:MeetingRoom) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
            this.sharedapi.presentToast(data.msg);
            setTimeout(() => {
              this.router.navigate(["update-meeting-room/"+data.meeting_room_id]);
            }, 2000);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error => 
        {
            this.sharedapi.checkError(error);
        });
    }
  }

}
